import { useIsMounted } from '@common/hooks';
import { isUndefined } from 'lodash';
import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { PaginationComponentProps } from 'react-data-table-component';
import ReactPaginate from 'react-paginate';

export const BasicDataTablePagination = observer(
  ({
    rowsPerPage,
    rowCount,
    onChangePage,
    currentPage,
    ...props
  }: PaginationComponentProps) => {
    const isMounted = useIsMounted();

    const pageNumbers = useMemo(() => {
      return Math.ceil(rowCount / rowsPerPage);
    }, [rowCount, rowsPerPage]);

    const lastIndex = currentPage * rowsPerPage;
    const firstIndex = lastIndex - rowsPerPage + 1;

    const handlePageChange = useCallback(
      (pageNumber: number) => {
        if (!isUndefined(pageNumber) && isMounted()) {
          onChangePage(pageNumber + 1, rowCount);
        }
      },
      [rowCount, onChangePage, isMounted],
    );

    const range =
      currentPage === pageNumbers
        ? `${firstIndex}-${rowCount} of ${rowCount}`
        : `${firstIndex}-${lastIndex} of ${rowCount}`;

    return (
      <nav
        className="pagination mt-3 px-1 d-flex justify-content-end align-items-center"
        data-testid="datapager"
      >
        <span className="me-3">{range}</span>
        <ReactPaginate
          pageCount={pageNumbers}
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          initialPage={currentPage - 1}
          onPageChange={(args) => handlePageChange(args.selected)}
          breakClassName={'page-item'}
          breakLinkClassName={'page-link'}
          containerClassName={'pagination justify-content-end mb-0'}
          pageClassName={'page-item'}
          pageLinkClassName={'page-link'}
          previousClassName={'page-item'}
          previousLinkClassName={'page-link'}
          nextClassName={'page-item'}
          nextLinkClassName={'page-link'}
          activeClassName={'active'}
        />
      </nav>
    );
  },
);
